import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'

const profileRepository = createApi({
	reducerPath: 'profileRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['Profile'],
	endpoints: (builder) => ({
		get: builder.query<
			{
				id: number
				name: string
				email: string
				curso_interesse_id: number
				nome_curso_interesse: string
				telephone?: string
				permissionId: number
				lastActive: string
				company: string
				companyId: number
				turma_id: number
				calendar: boolean
				show_modal_calendar: boolean
				show_modal_skill_mapping: boolean
				white_label: boolean
				turmas?: Array<{
					id: number
					nome: string
					vagas: number
					vagas_disponiveis: any
					aulas_marcadas: any
					nivel_id: number
					professor_id: number
					createdAt: string
					updatedAt: string
					empresa_id: number
					curso_id: number
					status: string
					data_inicio: any
					ciclo_id: any
					dias_da_semana: any[]
				}>
				onboarding_all?: Array<{
					curso_id: number
					nivel_onboarding: number
					proficiencia_id: number
					updatedAt: string
				}>
			},
			void
		>({
			query: () => ({
				url: `/v1/user/current_user`,
				method: 'GET',
			}),
			providesTags: ['Profile'],
		}),
		getMutation: builder.mutation<
			{
				id: number
				name: string
				email: string
				permissionId: number
				calendar: boolean
				show_modal_calendar: boolean
				show_modal_skill_mapping: boolean
				lastActive: string
				company: string
				companyId: number
				step: number
			},
			void
		>({
			query: () => ({
				url: `/v1/user/current_user`,
				method: 'GET',
			}),
			invalidatesTags: ['Profile'],
		}),
		editMutation: builder.mutation<
			void,
			{
				id: number
				curso_id?: number | null
				leveling_event_id?: string
				telephone?: string
				proficiencia_id?: number
				show_modal_progress_check?: boolean
				show_modal_calendar?: boolean
				show_modal_skill_mapping?: boolean
			}
		>({
			query: ({ id, ...body }) => ({
				url: `/v1/user/${id}/edit`,
				method: 'PATCH',
				body: body,
			}),
			invalidatesTags: ['Profile'],
			async onQueryStarted({ id, ...body }, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled
					// Após a mutação ser bem-sucedida, invalide a tag 'Profile' para forçar a atualização
					dispatch(profileRepository.util.invalidateTags(['Profile']))
				} catch (error) {
					// Lide com erros se necessário
					console.error('Edit mutation failed:', error)
				}
			},
		}),
		saveGoogleCalendarMutation: builder.mutation<
			void,
			{
				id: number
				calendario_code?: string
				calendario_refresh_token?: string
				calendario_email?: string
			}
		>({
			query: ({ id, ...body }) => ({
				url: `/v1/user/${id}/edit-google-calendar`,
				method: 'PATCH',
				body: body,
			}),
			invalidatesTags: ['Profile'],
			async onQueryStarted(_, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled
					// Após a mutação ser bem-sucedida, invalide a tag 'Profile' para forçar a atualização
					dispatch(profileRepository.util.invalidateTags(['Profile']))
				} catch (error) {
					// Lide com erros se necessário
					console.error('Edit mutation failed:', error)
				}
			},
		}),
	}),
})

export default profileRepository
